import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Link
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import logo from '../assets/Images/MainLogo.jpg';

const Footer = () => {
  const socials = [
    { icon: <FacebookIcon />, url: "https://www.facebook.com/tamilcars7777" },
    { icon: <InstagramIcon />, url: "https://www.instagram.com/tamilcars7777/" },
    { icon: <YouTubeIcon />, url: "https://www.youtube.com/@tamilcars7777" }
  ];

  const handleLinkClick = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback: scroll to top for hero section
      if (section === 'hero') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  return (
    <Box
      sx={{
        mt: 8,
        background: "linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0d1117 100%)",
        color: "#fff",
        pt: 6,
        pb: 4
      }}
      id="contact_us"
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent={"center"} >
          {/* Tamil Cars - Brand Column */}
          <Grid item xs={12} md={3} >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  border: "2px solid #d4af37",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(212, 175, 55, 0.1)",
                  flexShrink: 0
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="Tamil Cars Logo"
                  sx={{
                    width: 40,
                    height: 40,
                    objectFit: "contain"
                  }}
                />
              </Box>
              <Typography 
                variant="h4" 
                fontWeight="bold"
                sx={{
                  color: "#fff",
                  fontSize: { xs: "24px", md: "28px" }
                }}
              >
                Tamil Cars
              </Typography>
            </Box>
            <Typography 
              sx={{ 
                mt: 2, 
                color: "#e0e0e0", 
                fontSize: 14,
                lineHeight: 1.6
              }}
            >
              Trusted used cars & quality service.
            </Typography>
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
              {socials.map((s, i) => (
                <Box
                  key={i}
                  onClick={() => window.open(s.url)}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.15)",
                    cursor: "pointer",
                    transition: "0.3s",
                    "&:hover": {
                      background: "#ff6f00",
                      transform: "scale(1.1)"
                    }
                  }}
                >
                  {s.icon}
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Quick Links Column */}
          <Grid item xs={12} sm={6} md={2.5}>
            <Typography 
              fontWeight="bold" 
              sx={{
                color: "#d4af37",
                fontSize: "16px",
                mb: 1,
                pb: 1,
                borderBottom: "2px solid #d4af37"
              }}
            >
              QUICK LINKS
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 2 }}>
              <Link
                component="button"
                onClick={() => handleLinkClick('hero')}
                sx={{
                  color: "#fff",
                  fontSize: 14,
                  textDecoration: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  transition: "color 0.3s",
                  "&:hover": {
                    color: "#d4af37"
                  }
                }}
              >
                Browse Cars
              </Link>
              {/* <Link
                component="button"
                onClick={() => handleLinkClick('contact')}
                sx={{
                  color: "#fff",
                  fontSize: 14,
                  textDecoration: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  transition: "color 0.3s",
                  "&:hover": {
                    color: "#d4af37"
                  }
                }}
              >
                Sell Your Car
              </Link> */}
              {/* <Link
                component="button"
                onClick={() => handleLinkClick('contact')}
                sx={{
                  color: "#fff",
                  fontSize: 14,
                  textDecoration: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  transition: "color 0.3s",
                  "&:hover": {
                    color: "#d4af37"
                  }
                }}
              >
                Contact
              </Link> */}
            </Box>
          </Grid>

          {/* Contact Column */}
          <Grid item xs={12} sm={6} md={3.5}>
            <Typography 
              fontWeight="bold" 
              sx={{
                color: "#d4af37",
                fontSize: "16px",
                mb: 1,
                pb: 1,
                borderBottom: "2px solid #d4af37"
              }}
            >
              CONTACT
            </Typography>
            <Typography 
              sx={{ 
                mt: 2, 
                mb: 2,
                color: "#fff", 
                fontSize: 14,
                fontWeight: 500
              }}
            >
              Tamil Cars
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Box display="flex" gap={1.5} alignItems="flex-start">
                <LocationOnIcon sx={{ color: "#ef5350", fontSize: 20, mt: 0.5, flexShrink: 0 }} />
                <Typography sx={{ color: "#e0e0e0", fontSize: 13, lineHeight: 1.6 }}>
                  Salem – 636204
                </Typography>
              </Box>
              <Box display="flex" gap={1.5} alignItems="center">
                <PhoneIcon sx={{ color: "#9e9e9e", fontSize: 20, flexShrink: 0 }} />
                <Typography sx={{ color: "#e0e0e0", fontSize: 13 }}>
                  +91 9159967777
                </Typography>
              </Box>
              <Box display="flex" gap={1.5} alignItems="center">
                <AccessTimeIcon sx={{ color: "#9e9e9e", fontSize: 20, flexShrink: 0 }} />
                <Typography sx={{ color: "#e0e0e0", fontSize: 13 }}>
                  Mon - Sat: 9:00 AM – 9:00 PM
                </Typography>
              </Box>
              <Box display="flex" gap={1.5} alignItems="center">
                <EmailIcon sx={{ color: "#9e9e9e", fontSize: 20, flexShrink: 0 }} />
                <Typography sx={{ color: "#e0e0e0", fontSize: 13 }}>
                  tamilcars10@gmail.com
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Location Column */}
          <Grid item xs={12} md={3}>
            <Typography 
              fontWeight="bold" 
              sx={{
                color: "#d4af37",
                fontSize: "16px",
                mb: 1,
                pb: 1,
                borderBottom: "2px solid #d4af37"
              }}
            >
              LOCATION
            </Typography>
            <Box 
              sx={{ 
                mt: 2,
                width: "100%",
                height: { xs: "250px", md: "200px" },
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid rgba(255,255,255,0.1)"
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4229.487142067717!2d78.19230347534702!3d11.563318044186133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babef37df83fa7d%3A0x8f1b154f13253579!2sTamil%20cars!5e1!3m2!1sen!2sin!4v1771155052135!5m2!1sen!2sin" 

                // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.1234567890123!2d78.1234!3d11.6543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDM5JzE1LjUiTiA3OMKwMDcnMjQuMiJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Tamil Cars Location"
              />
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Copyright */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            mt: 4,
            pt: 3,
            textAlign: "center"
          }}
        >
          <Typography sx={{ fontSize: 12, color: "#9e9e9e" }}>
            © {new Date().getFullYear()} Tamil Cars — All Rights Reserved
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
